<div class="flex flex-col gap-4">
  <header class="flex flex-row items-center justify-between">
    <h1 class="text-3xl font-bold text-[color:var(--text-color)]">{{ 'financePages.payoutTitle' | translate }}</h1>
  </header>

  <bo-payout-request-kpi-list [kpis]="kpis()" />

  <div class="card !p-5">
    <bo-common-table
      [data]="data()"
      [columns]="columns"
      [config]="tableConfig"
      [dateRange]="dateRange()"
      [totalRecords]="totalRecords()"
      [mapFieldToSortBy]="mapColumnToSortBy"
      (searchChange)="onSearchChange($event)"
      (clearFilters)="onClearFilters()"
      (dateRangeChange)="onDateRangeChange($event)"
      (sortChangeRequested)="onSortChange($event)"
      (pageChangeRequested)="onPageChange($event)"
    >
      <ng-template #bodyTemplate let-data let-rowIndex="rowIndex">
        <tr class="cursor-pointer" (click)="onRowClick(data)">
          <td>
            <span>{{ data.payoutId }}</span>
          </td>
          <td>
            <bo-user-info-cell
              [firstName]="data?.organizer.name"
              lastName=""
              [email]="data?.organizer?.email"
              [avatarUrl]="data?.organizer?.avatarUrl ?? null"
            />
          </td>
          <td>
            <bo-currency-cell
              [value]="data?.payoutAmount"
              currency="EUR"
              locale="fr-FR"
              [showZero]="false"
              [minimumFractionDigits]="2"
              [maximumFractionDigits]="2"
            />
          </td>
          <td class="text-right">
            <bo-number-cell [value]="data.eventRequestCount" />
          </td>
          <td class="text-right">
            <bo-datetime-cell [date]="data.requestedDate" />
          </td>
          <td class="text-right">
            <bo-status-cell [status]="data.status" />
          </td>
        </tr>
      </ng-template>
    </bo-common-table>
    <bo-payout-request-detail
      [visible]="dialogVisible()"
      [payoutId]="selectedPayoutId()"
      (visibleChange)="onDialogVisibleChange($event)"
      (approved)="onApprove($event)"
      (declined)="onDecline($event)"
    ></bo-payout-request-detail>
    <bo-toast [title]="toastTitle()" [message]="toastMessage()" [icon]="toastIcon()" [visible]="toastVisible">
    </bo-toast>
  </div>
</div>
